module.exports = __webpack_public_path__ + "static/media/slide-curs-dictie.1145e418.jpg";